import { render, staticRenderFns } from "./MapSalesChannels.vue?vue&type=template&id=38df0f41&"
import script from "./MapSalesChannels.vue?vue&type=script&lang=js&"
export * from "./MapSalesChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports